"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorKilledEventArgs = void 0;
const EventType_1 = require("../EventType");
class ActorKilledEventArgs {
    constructor(killedById, killedId) {
        this.killedById = killedById;
        this.killedId = killedId;
        this.__type = EventType_1.EventType.ActorKilled;
        this.__typeName = "ActorKilled";
    }
}
exports.ActorKilledEventArgs = ActorKilledEventArgs;
